import React from 'react';
import { Helmet } from 'react-helmet-async';
import Typography from '@mui/material/Typography';
import { Button, Grid, IconButton, Link } from '@mui/material';
import Icon from 'src/components/color-utils/Icon';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { color } from 'framer-motion';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import DialogCalendar from 'src/components/dialog/dialogcalendar';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { set } from 'lodash';
import { getToken } from 'src/utils/common';

export default function CalendarPage() {
  //   const year = 2023; // Replace with the desired year
  //   const month = 1;
  const currentDate = new Date();
  const [year, setYear] = React.useState(currentDate.getFullYear());
  const currentMonthNumber = currentDate.getMonth() + 1; // Adding 1 to make it 1-based
  const [month, setMonth] = React.useState(currentMonthNumber);
  const daysArray = getDaysArrayByMonth(year, month);
  const [data, setData] = React.useState([]);
  const [calendardialog, setCalendarDialog] = React.useState({
    open: false,
    data: [],
    date: '',
  });
  const [search, setSearch] = React.useState('');

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d.data));
  };
  const handlemonth = (e) => {
    if (month >= 12) {
      setYear(year + 1);
      setMonth(1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=1' + '&year=' + (year + 1));
    } else {
      setMonth(month + 1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=' + (month + 1) + '&year=' + year);
    }
  };
  const handlemonthback = (e) => {
    if (month <= 1) {
      setYear(year - 1);
      setMonth(12);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=12' + '&year=' + (year - 1));
    } else {
      setMonth(month - 1);
      fetchInfo(window.REACT_APP_API_PURE + 'calendar/list?month=' + (month - 1) + '&year=' + year);
    }
  };

  React.useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'calendar/list');
  }, []);

  function Refresh() {
    fetchInfo(window.REACT_APP_API_PURE + 'calendar/list');
  }

  function getDaysArrayByMonth(year, month) {
    const daysArray = [];
    const startDate = new Date(year, month - 1, 1); // First day of the month
    const endDate = new Date(year, month, 0); // Last day of the month

    let currentDate = startDate;

    while (currentDate <= endDate) {
      daysArray.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return daysArray;
  }
  function getDayName(dateString) {
    const days = [
      t('Day.1'),
      t('Day.2'),
      t('Day.3'),
      t('Day.4'),
      t('Day.5'),
      t('Day.6'),
      t('Day.7')
    ];
    const date = new Date(dateString);
    const dayName = days[date.getDay()];
    return dayName;
  }
  function getDayNumber(dateString) {
    const date = new Date(dateString);
    const dayNumber = date.getDate();
    return dayNumber;
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function DayCard({ date, index }) {
    const isCurrentDate = date.toDateString() === currentDate.toDateString();

    const filteredData = data
      ?.filter((d) => {
        const timeStart = d.time_start.split(' ')[0] + ' 00:00:00Z';
        // console.log(timeStart);
        // console.log(formatDate(date.toLocaleDateString()));
        // console.log(formatDate(timeStart) === formatDate(date.toLocaleDateString()));
        return formatDate(timeStart) === formatDate(date.toLocaleDateString());
      })
      .sort((a, b) => {
        // Assuming 'a' and 'b' are objects with a 'time_start' property
        const timeStartA = new Date(a.time_start);
        const timeStartB = new Date(b.time_start);
        return timeStartA - timeStartB;
      });
    return (
      <div
        onClick={() => {
          if (filteredData != undefined) {
            setCalendarDialog({
              open: true,
              data: filteredData,
              date: isCurrentDate,
            });
          }
        }}
        style={{ height: 185, border: '1px solid #E7E7E7', padding: '10px', width: '100%' }}
      >
        {index == 0 ? <span style={{ color: '#888888' }}>{getDayName(date.toLocaleDateString())}</span> : ''}
        <div
          style={{
            marginLeft: 20,
            backgroundColor: isCurrentDate ? '#1EB3D9' : 'transparent',
            color: isCurrentDate
              ? 'white'
              : index == 28 && getDayNumber(date.toLocaleDateString()) < 28
              ? '#B0B0B0'
              : 'black',
            display: isCurrentDate ? 'inline-flex' : '',
            padding: isCurrentDate ? 2 : '',
            borderRadius: 5,
          }}
        >
          {getDayNumber(date.toLocaleDateString())}
        </div>
        {filteredData?.length == 0 || filteredData == undefined ? (
          ''
        ) : (
          <div>
            {' '}
            {filteredData
              ?.filter((d) => {
                if (search == '') {
                  return d;
                } else {
                  return d.title.toLowerCase().includes(search.toLowerCase());
                }
              })
              .map((d, index) => {
                if (index < 3) {
                  return (
                    <div>
                      <Typography
                        variant="caption"
                        style={{
                          borderRadius: 5,
                          padding: 5,
                          backgroundColor:
                            d.schedule == 'Daily' ? '#1EB3D9' : d.schedule == 'Weekly' ? '#8667EB' : '#F9A207',
                          width: '100%',
                          display: 'flex',
                          placeItems: 'center',
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        <FolderCopyIcon fontSize="5px" /> {d.title.length > 10 ? `${d.title.slice(0, 10)}...` : d.title}
                      </Typography>

                      <div style={{ paddingTop: 5 }} />
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            {/* <Typography
              variant="caption"
              style={{ borderRadius: 5, padding: 5, backgroundColor: '#8667EB', color: 'white' }}
            >
              <FolderCopyIcon fontSize="5px" /> {filteredData[0].title}
            </Typography>
            <div style={{ paddingTop: 5 }} />
            <Typography
              variant="caption"
              style={{ borderRadius: 5, padding: 5, backgroundColor: '#1EB3D9', color: 'white' }}
            >
              <FolderCopyIcon fontSize="5px" /> {filteredData[0].title}
            </Typography>
            <div style={{ paddingTop: 5 }} />
            <Typography
              variant="caption"
              style={{ borderRadius: 5, padding: 5, backgroundColor: '#F9A207', color: 'white' }}
            >
              <FolderCopyIcon fontSize="5px" /> {filteredData[0].title}
            </Typography> */}
            <div />
            {filteredData.length <= 3 ? (
              ''
            ) : (
              <Link
                onClick={() => {
                  setCalendarDialog({
                    open: true,
                    data: filteredData,
                    date: isCurrentDate,
                  });
                }}
              >
                <Typography style={{ cursor: 'pointer' }} variant="caption">
                  {filteredData.length - 3} more
                </Typography>
              </Link>
            )}{' '}
          </div>
        )}
      </div>
    );
  }

  function DayList({ daysArray }) {
    const rows = [];

    const getDaysArrayByMonth = (year, month) => {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => new Date(year, month - 1, i + 1));
    };

    // Calculate the number of days needed to pad to reach a total of 35 days
    const remainingDays = 35 - daysArray.length;

    // Get the next month's days to fill the remaining days
    const nextMonth = getDaysArrayByMonth(year, month + 1); // You can replace 6 with the next month

    const paddedDaysArray = [...daysArray, ...nextMonth.slice(0, remainingDays)];

    for (let i = 0; i < paddedDaysArray.length; i += 7) {
      const rowDays = paddedDaysArray.slice(i, i + 7);
      rows.push(
        <div style={{ display: 'flex' }} key={i}>
          {rowDays.map((day, index) => {
            return <DayCard key={index} date={day} index={i} />;
          })}
        </div>
      );
    }

    return <div>{rows}</div>;
  }
  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  function getMonthName(monthNumber) {
    const months = [
      t('Month.1'),
      t('Month.2'),
      t('Month.3'),
      t('Month.4'),
      t('Month.5'),
      t('Month.6'),
      t('Month.7'),
      t('Month.8'),
      t('Month.9'),
      t('Month.10'),
      t('Month.11'),
      t('Month.12')
    ];

    // Ensure the monthNumber is in the valid range (1 to 12)
    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    } else {
      // Handle invalid month number
      return 'Invalid Month';
    }
  }
  function handleClose() {
    setCalendarDialog((current) => ({
      ...current,
      open: false,
    }));
  }

  return (
    <div>
      <Helmet>
        <title>Calendar | SmartShield</title>
      </Helmet>
      {
        <DialogCalendar
          open={calendardialog.open}
          data={calendardialog.data}
          handleClose={handleClose}
          date={calendardialog.date}
          refresh={Refresh}
        />
      }
      <Grid container direction="row">
        <Grid item xs={2}>
          {' '}
          <Typography variant="h4" sx={{ p: 2, paddingLeft: 5 }}>
            {getMonthName(month)}
            {'    '}
            {year}
          </Typography>
        </Grid>
        <Grid item alignSelf={'center'} xs={1}>
          {' '}
          <IconButton style={{ color: '#12A2CE' }} onClick={handlemonthback}>
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton style={{ color: '#12A2CE' }} onClick={handlemonth}>
            <ArrowForwardIosIcon />
          </IconButton>
        </Grid>
        <Grid
          item
          xs={9}
          spacing={2}
          alignContent={'center'}
          style={{ textAlignLast: 'right' }}
          container
          direction="row"
          justifyContent={'flex-end'}
        >
          <Grid item>
            <Button
              onClick={() => {
                setYear(currentDate.getFullYear());
                setMonth(currentDate.getMonth() + 1);
                fetchInfo(
                  window.REACT_APP_API_PURE +
                    'calendar/list?month=' +
                    (currentDate.getMonth() + 1) +
                    '&year=' +
                    currentDate.getFullYear()
                );
              }}
              variant="outlined"
            >
              {t('Today.1')}
            </Button>
          </Grid>
          <Grid item>
            {' '}
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              label={t('Search.1')}
              style={{ paddingRight: 20, textAlignLast: 'left' }}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              value={search}
              InputProps={{
                endAdornment: (
                  <IconButton type="submit" aria-label="search">
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* {daysArray.map((day) => { */}
      <DayList daysArray={daysArray} />
      <div style={{ height: 50 }}></div>
      {/* })} */}
    </div>
  );
}
